/* tslint:disable:no-trailing-whitespace import-spacing no-inferrable-types typedef-whitespace */

import { Injectable         } from '@angular/core';

import { ModalComponent     } from '../components/modal.component';
import { IValidatorCallBack } from '@/gui/dialogs/i.validator.call.back';
import { IOkCallBack        } from '@/gui/dialogs/i.ok.call.back';

@Injectable({
  providedIn: 'root'
})

/**
 *
 * @class ModalService
 *
 * @brief allow anyone to open/close available modal dialogs
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      April 2020
 *
 */
export class ModalService {

  /** the pool of available modals */
  private modals: ModalComponent[] = [];

  /** currently active modal, if there is one */
  private active: ModalComponent = null;

  /** fetch the currently active modal (if there is one) */
  modalShown() : ModalComponent {

    return this.active;
  }

  /** make a dialog available */
  add(modal: ModalComponent) {

    this.modals.push(modal);
  }

  /** remove an available dialog */
  remove(id: string) {

    this.modals = this.modals.filter(x => x.id !== id);
  }

  /** open a modal dialog */
  open(id: string, validator?: IValidatorCallBack, success?: IOkCallBack, options?: any) {

    /* if something is already open...auto close */

    if (this.active) {

      this.active.close();

      this.active = null;
    }

    /* open the requested dialog */

    const modal: any = this.modals.filter(x => x.id === id)[0];

    this.active = modal;

    modal.open(validator, success, options);
  }

  /** close a modal dialog */
  close() {

    if (!this.active) {

      /* nothing to do */

      return ;
    }

    this.active.close();

    this.active = null;
  }

  /** the active modal was dismissed */
  dismissed() {

    this.active = null;
  }
}
